import { motion } from "framer-motion";

import type { IConcreteEffectProps } from "../types.js";

import { Animatable } from "./Animatable";

export function ZoomIn({
  ease,
  active,
  onClick,
  duration,
  children,
  className,
}: IConcreteEffectProps) {
  return (
    <Animatable active={active}>
      <motion.div
        key="zoomIn"
        onClick={onClick}
        className={className}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.75, opacity: 0 }}
        initial={{ scale: 0.75, opacity: 0 }}
        transition={{ duration: duration ?? 0.2, ease: ease ?? "easeOut" }}>
        {children}
      </motion.div>
    </Animatable>
  );
}
